import { createNanoEvents } from 'nanoevents';

const events = createNanoEvents();

export default events;